import React, { useState, useEffect } from 'react';
import TableCell from '@mui/material/TableCell';
import { useNavigate } from 'react-router-dom';
import axios from "../../../lib/axios";
import TableComponent from '../../../atoms/TableComponent/DataTable';
import { usePermissions } from '../../../GlobalFunction/userPermissions';
import { Box, Button, Tooltip, Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const columns = [
  { id: 'RowNum', label: 'S.No.', width: 130 },
  { id: 'CountryCode', label: 'Country Code', minWidth: 160 },
  { id: 'Country', label: 'Country', minWidth: 170 }, 
  { id: 'CountryAbrv', label: 'Short Name', minWidth: 130 },
  { id: 'Status', label: 'Status', minWidth: 160 }
];

export default function CountryTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCountryData();
  }, []);

  const permissions = usePermissions("Country Master");

  const { AddRec = "0" } = permissions || {};

  const handlePermittedClick = () => {
    if (AddRec === "1") {
      handleClick();
    }
  };

  const fetchCountryData = async () => {
    try {
      const response = await axios.post('CountryMst/getAllCountryMasterDashBoard', {
        start: 1,
        PageSize: 1,
        SearchText: ""
      });
      console.log("res", response);

      if (response.data.Status === 0) {
        const formattedData = response.data.Data.map(country => ({
          ...country,
          Country: country.CountryName,
          Status: country.Status === null ? '' : (country.Status == 1 ? 'Active' : 'Inactive') 
        }));
        setRows(formattedData);
      } else {
        console.error('Error fetching country data:', response.data.message);
      }
    } catch (error) {
      console.error('Error fetching country data:', error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    navigate('/country');
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleExit = () => {
    navigate('/masters/location')
  }

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, rows]);

  const handleRowDoubleClick = (row) => {

    navigate('/country', { state: { CountryId: row.CountryId, mode: 'view' } });
  };

  const handleLocationclick = () => {
    navigate('/masters/location')
  }

  const Extractor = ({ row, ind }) => (
    <TableCell 
      key={ind} 
      align="left" 
      sx={{ 
        display: 'flex',
        padding: '8px !important',
        // width: '170px', 
        minWidth: '60px',
        '& img': {
          width: '20px', 
          height: '20px', 
          borderRadius: '50%'
        },
        '& div': {
          margin: "0 0 0 8px", 
          fontSize: '0.875rem' 
        }
      }}
    >
      <img
        src={row.CountryIcon}
        alt=""
        style={{ flexShrink: 0 }}
      />
      <div>{row[columns[0].id]}</div>
    </TableCell>
  );

  const addButtonStyles = {
    background: AddRec === "1" ? "#635bff" : "rgba(0, 0, 0, 0.12)",
    color: AddRec === "1" ? "white" : "rgba(0, 0, 0, 0.26)",
    borderRadius: "50px",
    padding: "8px 20px",
    boxShadow: AddRec === "1" ? "0px 6px 15px rgba(0, 0, 0, 0.3)" : "none",
    transition: "background 0.3s ease",
    "&:hover": {
      background: AddRec === "1" ? "#524ccc" : "rgba(0, 0, 0, 0.12)"
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)"
    }
  };

  const Filters = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Tooltip 
        title={AddRec !== "1" ? "You have no permission to add record" : ""}
        placement="top"
      >
        <span> 
          <Button
            variant="contained"
            onClick={handlePermittedClick}
            size="small"
            disabled={AddRec !== "1"}
            sx={addButtonStyles}
          >
            <AddIcon/>New
          </Button>
        </span>
      </Tooltip>
    </Box>
  );  

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      filteredRows={filteredRows}
      page={page}
      CountryJsx={Extractor}
      FiltersJsx={Filters}
      title="Location"
      titleMaster="Country Master"
      rowsPerPage={rowsPerPage}
      handleRowDoubleClick={handleRowDoubleClick}
      handleSearchChange={handleSearchChange}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      handleClick={handleClick}
      handleHomeClick={handleHomeClick}
      handleLocationclick={handleLocationclick}
    />
  );
}